/**
 * 用户权限相关，用于个人中心的接口
 */
import { getLocalZhiyinUser } from '@/components/UserModal/utils';
import axios from '@/services/axios';
import { getLocalToken } from '@/utils';

interface ResProps {
  code: number;
  data: any;
  msg: string;
}
export const axiosWrapper = (fun) => {
  return fun
    .then((res: ResProps) => {
      if (res.code == 200 && res.msg == 'OK') {
        return res.data;
      } else {
        return Promise.reject(new Error('服务器出错了'));
      }
    })
    .catch((err) => {
      return Promise.reject({ msg: err?.response?.data?.msg || '服务器出错了' });
    });
};

export const unBindOrg = (parmas: any) => {
  return axiosWrapper(axios.post(`/admin/v1/unBindOrg`, parmas));
};

export const bindOrg = (params: any) => {
  return axiosWrapper(axios.post(`/admin/v1/bindOrg`, params));
};

export const transferPermission = (params: any) => {
  return axiosWrapper(axios.post(`/admin/v1/transferPermission`, params));
};

export const getUserListByOrg = (param: any) => {
  return axiosWrapper(axios.post(`/admin/v1/getUserListByOrg`, { ...param }));
};

export const checkPhoneBind = () => {
  return axios.post(`/admin/v1/checkPhoneBind`);
};

export const checkPhoneUser = (params: { phone: any }) => {
  return axiosWrapper(axios.post(`/admin/v1/getUserByPhone`, params));
};

export const updateOrg = (params: any) => {
  return axiosWrapper(axios.post(`/admin/v1/updateOrg`, params));
};

export const checkPhoneIsExist = () => {
  return axios.post(`/admin/v1/checkPhoneIsExist`);
};
export const getOrgByID = (id: number) => {
  return axiosWrapper(axios.post(`/admin/v1/getOrg`, { id }));
};

//  获取 aminer 性别和头像 信息
export const getBaseInfo = () => {
  return axios.post(`/aminer-old-api/magic`, [{ action: 'user.GetMe' }]).then((res) => {
    if (res?.data?.[0]?.succeed) {
      return res.data[0].items;
    } else {
      return Promise.reject(res);
    }
  });
};

/**
 *
 * @param parameters "parameters": {
            "id": "59c5b98d9ed5db7081dd1510",
            "fname": "jun",
            "lname": "zhao",
            "name": "jun zhao",
            "gender": 2,
            "title": "other",
            "subject": "Communication and Informatica Science",
            "org": ""
        }
 * @returns
 */
export const updateUserGender = (parameters: any) => {
  return axios.post(`/aminer-old-api/magic`, [{ action: 'userapi.update', parameters }]);
};

// 修改用户头像
export const uploadAvatar = (formData: any) => {
  return axios({
    url: `/aminer-old-api/magic`,
    method: 'post',
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    data: formData,
  })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return null;
    });
};

interface updateProps {
  id: number;
  paypermission: number;
  pay: number;
  free: number;
  freePermission: number;
  name?: string;
  phone?: string;
}
/**
 *
 * @param params 更改用户信息
 * @returns
 */
export function updateUser(params: updateProps) {
  return axios.post(`/admin/v1/updateUser`, params);
}

interface unbindUserProps {
  kind: 1 | 2 | 3; // 1: 2:邮箱 3:手机号
  kindValue: string;
}
export function unbindUser(params: unbindUserProps) {
  return axios.get(`/aminer-api/api/v0/user/unBind`, { params });
}

//获取用户绑定信息
export function getBindUserInfo() {
  return axios.get(`/aminer-api/api/v0/user/bind`);
}

//获取搜索记录
interface searchRecordProps {
  uid: number;
  search_type?: number;
  searches?: string;
  current: number;
  page_size: number;
  start_date: string;
  end_date: string;
}
export function searchSearchRecord(props: searchRecordProps) {
  return axiosWrapper(axios.post(`/admin/v1/searchSearchRecord`, props));
}

//删除搜索记录
export function delSearchRecord(ids: number[]) {
  return axiosWrapper(axios.post(`/admin/v1/delSearchRecord`, { ids }));
}

//新增一个检索记录
export type AddSearchRecordProps =
  | {
      uid: number;
      search_type: 1; // 1 简单搜索
      searches: string; // 必传
    }
  | {
      uid: number;
      search_type: 2; // 2 复杂搜索
      searches: string; // 必传
      title: string; // 必传
    };

export function addSearchRecord(props: AddSearchRecordProps) {
  return axiosWrapper(axios.post(`/admin/v1/setSearchRecord`, props)).then((data) => {
    const newId = window.btoa(data.id);
    data.id = newId;
    return data;
  });
}
// 根据id获取用户检索记录
export function getSearchRecordById(id: number) {
  return axiosWrapper(axios.post(`/admin/v1/getSearchRecordById`, { id }));
}

//上传 exel 文件
export function uploadExcelFile(formData: any) {
  return axiosWrapper(axios.post(`/admin/v1/bachInviteUserCsvCheck`, formData));
}

//清除用户检索记录
export function clearSearchRecord(uid: number, search_type = 0) {
  return axiosWrapper(axios.post(`/admin/v1/clearSearchRecord`, { uid, search_type }));
}

export function getManageLog(params: any) {
  return axiosWrapper(axios.post(`/admin/v1/getManageLog`, params));
}

// 解绑手机号，解绑邮箱
/**
 *
 * @param params

 * kind 3 手机号 2 邮箱
   kindValue 值
 * @returns
 */
export function unbindInfoFun(params: any) {
  return unbindUser(params);
}

// 绑定手机号，邮箱
/**
 *
 * @param params

   "category": 2 手机 3 邮箱,
    "code": "验证码",
    "username": 手机号 邮箱
 * @returns
 */
export function bindInfoFun(params: any) {
  return axios.post(`/aminer-api/api/v0/user/bind`, params);
}

// 获取会员商品列表
export function getGoodsList() {
  return axiosWrapper(axios.post(`/admin/v1/product/product/productList`));
}

// 增加会员订单
export function addOrder(AddOrderReq: {
  productId: number;
  userId: any;
  userName: any;
  payType: number;
  sourceType: number;
  orderType: number;
}) {
  return axiosWrapper(axios.post(`/admin/v1/order/order/addForQr`, AddOrderReq));
}

// 查看订单状态
export function checkOrder(OrderStatusReq: string) {
  return axiosWrapper(axios.post(`/admin/v1/order/order/orderStatus`, { orderSn: OrderStatusReq }));
}

interface ListOrderReq {
  current: number;
  pageSize: number;
  userId?: number; // 用户id
  date: string[];
}

export function orderListForUser(req: ListOrderReq) {
  return axiosWrapper(axios.post('/admin/v1/order/order/userOrder', req));
}

export function orderDeleteForUser(req: string) {
  return axios.post('/admin/v1/order/order/delete', { orderSn: req });
}

// 创建发票 /admin/v1/order/invoice/create

export function createInvoice(req: {
  bill_type: 'string';
  status: 0;
  bill_header: 'string';
  tax_number: 'string';
  bank_name: 'string';
  bank_account: 'string';
  register_address: 'string';
  register_phone: 'string';
  id_number: 'string';
  email: 'string';
  pay_proof: ['string'];
  amount: 0;
  user_id: 0;
  user_name: 'string';
  mobile: 'string';
  order_number: ['string'];
  pay_transaction: ['string'];
}) {
  return axiosWrapper(axios.post(`/admin/v1/order/invoice/create`, req));
}
